/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'portal': {
    width: 15,
    height: 15,
    viewBox: '0 0 15 15',
    data: '<path pid="0" d="M9.44 14.423c0 .319.258.577.577.577h4.406a.577.577 0 0 0 .577-.577V.577A.577.577 0 0 0 14.423 0h-4.406a.577.577 0 1 0 0 1.154h3.83v12.692h-3.83a.577.577 0 0 0-.577.577zM0 7.5c0 .319.258.577.577.577l8.048-.001-3.42 3.422a.577.577 0 1 0 .815.816l4.399-4.4a.58.58 0 0 0 .042-.045l-.036.039a.575.575 0 0 0 .162-.5l.007.092a.581.581 0 0 0-.175-.415l-4.4-4.399a.577.577 0 1 0-.815.816l3.42 3.421H.577A.577.577 0 0 0 0 7.5z" _fill="#848484" fill-rule="nonzero"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/portal.js